























































import { FactureFournisseur } from "../../models/FactureFournisseur";

export default {
    name: "FactureFournisseurModalDisplay",
    props: {
        factureFournisseur: FactureFournisseur
    }
};
